export default __webpack_public_path__ + "quick-actions-what-is-coming.3d7bd3d5.svg";